import './styles.scss';

export default function initTables() {
  if (document.querySelectorAll('.page-content table').length > 0) {
    // declaring vars
    var contentTable = document.querySelectorAll('.page-content table');
    var tableResponsive = document.getElementsByClassName('table-responsive');
    var tableWrap = document.getElementsByClassName('table-wrap');
    var scrollLabel = document.getElementsByClassName('scroll-label');

    for (let i = 0; i < contentTable.length; i++) {
      // Add Bootstrap classes to tables.
      contentTable[i].classList.add('table');
      contentTable[i].classList.add('table-striped');

      var thead = contentTable[i].querySelector('thead');
      if (thead) {
        thead.classList.add('thead-dark');
      }

      //wrap each table current implmentation
      var wrapResonnsive = document.createElement('div');
      wrapResonnsive.setAttribute('class', 'table-responsive');
      contentTable[i].parentNode.insertBefore(wrapResonnsive, contentTable[i]);
      wrapResonnsive.appendChild(contentTable[i]);

      //wrap each table responsive to control toggle
      var wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'table-wrap mb-3');
      tableResponsive[i].parentNode.insertBefore(wrapper, tableResponsive[i]);
      wrapper.appendChild(tableResponsive[i]);

      //add scroll label to the bottom
      tableWrap[i].insertAdjacentHTML(
        'beforeend',
        '<div class="text-muted scroll-label pr-4 text-right d-none">Scroll for more content</div>'
      );
    }

    //loop through tables toggle class to show right side shards
    for (let i = 0; i < tableResponsive.length; i++) {
      if (contentTable[i].offsetWidth > tableResponsive[i].offsetWidth) {
        tableWrap[i].classList.add('table-overflow');
        tableWrap[i].classList.add('pt-3');
        scrollLabel[i].classList.remove('d-none');
      } else if (contentTable[i].offsetWidth < tableResponsive[i].offsetWidth) {
        tableWrap[i].classList.remove('table-overflow');
        scrollLabel[i].classList.add('d-none');
      }
    }

    //Watch for window resize
    window.addEventListener(
      'resize',
      function () {
        for (let i = 0; i < tableResponsive.length; i++) {
          if (contentTable[i].offsetWidth > tableResponsive[i].offsetWidth) {
            tableWrap[i].classList.add('table-overflow');
            scrollLabel[i].classList.remove('d-none');
          } else if (
            contentTable[i].offsetWidth <= tableResponsive[i].offsetWidth
          ) {
            tableWrap[i].classList.remove('table-overflow');
            scrollLabel[i].classList.add('d-none');
          }
        }
      },
      true
    );
  }
}
